import React, { useEffect, useState } from "react";

import NAV from "./nav";
import Carousel from "./carousel";

import MFWealthCalculator from "../components/mf/MFWealthCalculator";
import TopFundsTable from "../components/mf/TopFundsTable";
import CategorySnapshot from "../components/mf/CategorySnapshot";
import RiskReturnChart from "../components/mf/RiskReturnChart";
import CategoryHeatmap from "../components/mf/CategoryHeatmap";
import ConsistentFunds from "../components/mf/ConsistentFunds";
import MFARNCard from "../components/mf/MFARNCard";
import MFFloatingAdvisorWidget from "../components/mf/MFFloatingAdvisorWidget";
import MFSubnav from "../components/mf/MFSubnav";

import { Sparkles, ShieldCheck, Building2 } from "lucide-react";

import { fetchMFDB } from "../api";

import pru_logo from "../img/logos/prudent_logo.png"
import sbi_logo from "../img/logos/SBI_mf.jpg"
import kotak_logo from "../img/logos/kotak_mf.png"
import aditya_logo from "../img/logos/aditya_birla_mf.jpg"
import nippon_logo from "../img/logos/nippon_mf.png"
import fundbazar_logo from "../img/logos/nippon_mf.png"


const MFHomeStandalone = () => {

  const [dashboardData, setDashboardData] =
    useState(null);

  const [loading, setLoading] =
    useState(true);

  const partnerLogos = [
    {
      name: "ICICI Prudential",
      logo: pru_logo,
    },
    {
      name: "SBI Mutual Fund",
      logo: sbi_logo,
    },
    {
      name: "Kotak Mutual Fund",
      logo: kotak_logo,
    },
    {
      name: "Nippon India Mutual Fund",
      logo: nippon_logo,
    },
    {
      name: "Aditya Birla Sun Life",
      logo: aditya_logo,
    },
    {
      name: "More Coming Soon",
      logo: fundbazar_logo,
    },
  ];


  // =====================================================
  // INIT
  // =====================================================

  useEffect(() => {

    fetchMFDB()
      .then((data) => {

        setDashboardData(data);

        setLoading(false);

      });

  }, []);


  if (loading) {

    return (
      <div className="min-h-screen bg-[#f5f7f8] flex items-center justify-center text-2xl font-bold">
        Loading...
      </div>
    );
  }


  return (

    // <div className="bg-[#f5f7f8] text-gray-900">
    <div className="bg-surface text-on-surface font-body">


      {/* =====================================================
          HERO SECTION
      ===================================================== */}

      <div className="relative">

        <NAV activetag="mf" />

        {/* Push content below fixed navbar */}
        {/*<div className="pt-[110px]">*/}
        <div className="pt-[630px]">

          <MFSubnav active="overview" />

          {/*<div className="relative h-[520px] overflow-hidden">*/}

            <Carousel activetag="mf" />

            {/* OVERLAY */}

            <div
              className="
                absolute
                inset-0
                bg-gradient-to-r
                from-black/70
                via-black/45
                to-black/20
              "
            />

            {/* HERO CONTENT */}

            <div
              className="
                absolute
                inset-0
                flex
                items-center
              "
            >

              <div
                className="
                  w-full
                  px-6
                  lg:px-12
                  xl:px-20
                "
              >

                <div className="max-w-4xl">

                  {/* TAG */}

                  <div
                    className="
                      inline-flex
                      items-center
                      gap-2
                      px-4
                      py-2
                      rounded-full
                      bg-white/10
                      backdrop-blur-md
                      border
                      border-white/20
                      text-white
                      mb-6
                    "
                  >
                    <Sparkles size={18} />
                    Institutional Grade Mutual Fund Analytics
                  </div>


                  {/* TITLE */}

                  <h1
                    className="
                      text-5xl
                      lg:text-7xl
                      font-black
                      text-white
                      leading-tight
                      mb-8
                    "
                  >
                    Discover The Best
                    <span className="block text-green-400">
                      Mutual Funds
                    </span>
                  </h1>


                  {/* SUBTITLE */}

                  <p
                    className="
                      text-white/85
                      text-lg
                      lg:text-xl
                      leading-relaxed
                      max-w-2xl
                    "
                  >
                    Explore professionally curated
                    mutual funds with advanced
                    performance analytics,
                    category insights and
                    institutional-grade screening
                    tools.
                  </p>


                  {/* CTA */}

                  <div
                    className="
                      flex
                      flex-wrap
                      gap-5
                      mt-10
                    "
                  >

                    <a href="/mfe/">

                      <button
                        className="
                          bg-green-500
                          hover:bg-green-600
                          text-white
                          px-8
                          py-4
                          rounded-2xl
                          font-bold
                          text-lg
                          shadow-xl
                          transition-all
                          hover:scale-105
                        "
                      >
                        Explore Funds
                      </button>

                    </a>


                    <a href="/mfpartners/">

                      <button
                        className="
                          bg-white/10
                          hover:bg-white/20
                          backdrop-blur-md
                          border
                          border-white/20
                          text-white
                          px-8
                          py-4
                          rounded-2xl
                          font-bold
                          text-lg
                          transition-all
                        "
                      >
                        Our AMC Partners
                      </button>

                    </a>

                  </div>

                </div>

              </div>

            </div>

          {/*</div>*/}

        </div>

      </div>


      {/* FLOATING WIDGET */}

      <MFFloatingAdvisorWidget />


      {/* =====================================================
          TRUST BAR
      ===================================================== */}

      <section
        className="
          px-6
          lg:px-10
          -mt-16
          relative
          z-20
        "
      >

        <div
          className="
            max-w-7xl
            mx-auto
            bg-white
            rounded-[32px]
            shadow-[0_15px_50px_rgba(0,0,0,0.08)]
            border
            border-gray-100
            p-8
          "
        >

          <div
            className="
              grid
              md:grid-cols-3
              gap-8
            "
          >

            <div className="flex gap-5">

              <div
                className="
                  w-14
                  h-14
                  rounded-2xl
                  bg-green-100
                  flex
                  items-center
                  justify-center
                  text-green-700
                "
              >
                <ShieldCheck size={28} />
              </div>

              <div>

                <div className="font-black text-xl mb-2">
                  ARN Registered
                </div>

                <div className="text-gray-500">
                  AMFI registered distributor
                  with partnered AMCs
                </div>

              </div>

            </div>


            <div className="flex gap-5">

              <div
                className="
                  w-14
                  h-14
                  rounded-2xl
                  bg-blue-100
                  flex
                  items-center
                  justify-center
                  text-blue-700
                "
              >
                <Building2 size={28} />
              </div>

              <div>

                <div className="font-black text-xl mb-2">
                  Direct AMC Access
                </div>

                <div className="text-gray-500">
                  Invest directly through
                  trusted AMC partner platforms
                </div>

              </div>

            </div>


            <div className="flex gap-5">

              <div
                className="
                  w-14
                  h-14
                  rounded-2xl
                  bg-purple-100
                  flex
                  items-center
                  justify-center
                  text-purple-700
                "
              >
                <Sparkles size={28} />
              </div>

              <div>

                <div className="font-black text-xl mb-2">
                  Orion Intelligence
                </div>

                <div className="text-gray-500">
                  Advanced fund analytics,
                  ranking and screening engine
                </div>

              </div>

            </div>

          </div>

        </div>

      </section>


      {/* =====================================================
          WEALTH + ARN SECTION
      ===================================================== */}

      <section className="py-24 px-6 lg:px-10">

        <div
          className="
            max-w-7xl
            mx-auto
            grid
            lg:grid-cols-2
            gap-10
            items-start
          "
        >

          {/* LEFT */}

          <div className="space-y-8">

            <div>

              <div
                className="
                  inline-flex
                  items-center
                  gap-2
                  px-4
                  py-2
                  rounded-full
                  bg-green-100
                  text-green-700
                  font-semibold
                  mb-6
                "
              >
                Premium Advisory Access
              </div>

              <h2
                className="
                  text-5xl
                  font-black
                  leading-tight
                  mb-6
                "
              >
                Invest Through
                Trusted AMC
                Platforms
              </h2>

              <p
                className="
                  text-lg
                  text-gray-600
                  leading-relaxed
                "
              >
                Start SIPs and investments
                directly via empanelled AMC
                portals linked to your Orion
                Analytics advisory ecosystem.
              </p>

            </div>

            <MFARNCard />

          </div>


          {/* RIGHT */}

          <div
            className="
              bg-white
              rounded-[32px]
              p-8
              shadow-[0_10px_40px_rgba(0,0,0,0.06)]
              border
              border-gray-100
            "
          >

            <MFWealthCalculator />

          </div>

        </div>

      </section>


      {/* =====================================================
          AMC PARTNER SHOWCASE
      ===================================================== */}

      <section
        className="
          py-20
          px-6
          lg:px-10
          bg-white
        "
      >

        <div className="max-w-7xl mx-auto">

          <div className="mb-12">

            <div
              className="
                text-sm
                uppercase
                tracking-[0.3em]
                text-green-700
                font-bold
                mb-4
              "
            >
              Trusted Distribution Network
            </div>

            <h2
              className="
                text-4xl
                lg:text-5xl
                font-black
                mb-4
              "
            >
              Partnered AMC Ecosystem
            </h2>

            <p
              className="
                text-lg
                text-gray-600
                max-w-3xl
              "
            >
              Orion Analytics works with
              leading mutual fund houses
              enabling seamless investment
              access and advisory workflows.
            </p>

          </div>


          {/* LOGO GRID */}

          <div
            className="
              grid
              grid-cols-2
              md:grid-cols-3
              lg:grid-cols-6
              gap-6
            "
          >

            {/*{[*/}
            {/*  "SBI",*/}
            {/*  "HDFC",*/}
            {/*  "ICICI",*/}
            {/*  "Nippon",*/}
            {/*  "Kotak",*/}
            {/*  "Franklin",*/}
            {/*].map((amc, idx) => (*/}

            {/*  <div*/}
            {/*    key={idx}*/}
            {/*    className="*/}
            {/*      bg-[#f8faf9]*/}
            {/*      rounded-3xl*/}
            {/*      h-[120px]*/}
            {/*      flex*/}
            {/*      items-center*/}
            {/*      justify-center*/}
            {/*      border*/}
            {/*      border-gray-100*/}
            {/*      hover:border-green-300*/}
            {/*      hover:shadow-lg*/}
            {/*      transition-all*/}
            {/*    "*/}
            {/*  >*/}

            {/*    <div*/}
            {/*      className="*/}
            {/*        text-2xl*/}
            {/*        font-black*/}
            {/*        text-gray-700*/}
            {/*      "*/}
            {/*    >*/}
            {/*      {amc}*/}
            {/*    </div>*/}

            {/*  </div>*/}

            {/*))}*/}

          </div>

          <div
            className="
              grid
              grid-cols-2
              md:grid-cols-3
              lg:grid-cols-6
              gap-6
            "
          >

            {partnerLogos.map((amc, idx) => (

              <div
                key={idx}
                className="
                  group
                  bg-[#f8faf9]
                  rounded-3xl
                  h-[130px]
                  p-4
                  flex
                  flex-col
                  items-center
                  justify-center
                  border
                  border-gray-100
                  hover:border-green-300
                  hover:shadow-xl
                  hover:-translate-y-1
                  transition-all
                "
              >

                <img
                  src={amc.logo}
                  alt={amc.name}
                  className="
                    max-h-14
                    object-contain
                    mb-3
                    transition-all
                    group-hover:scale-105
                  "
                />

                <div
                  className="
                    text-xm
                    font-semibold
                    text-center
                    text-gray-600
                    leading-tight
                  "
                >
                  {amc.name}
                </div>

              </div>

            ))}

          </div>

          <div className="text-center mt-12">

            <a href="/mfpartners/">

              <button
                className="
                  bg-green-700
                  hover:bg-green-800
                  text-white
                  px-8
                  py-4
                  rounded-2xl
                  font-bold
                  text-lg
                  transition-all
                "
              >
                View All Partner Platforms
              </button>

            </a>

          </div>

        </div>

      </section>


      {/* =====================================================
          ANALYTICS
      ===================================================== */}

      <section className="py-24 px-6 lg:px-10">

        <div className="max-w-7xl mx-auto">

          <h2 className="text-5xl font-black mb-12">
            Mutual Fund Performance
          </h2>

          <div className="grid md:grid-cols-4 gap-8">

            <div
              className="
                md:col-span-2
                bg-white
                p-8
                rounded-[32px]
                shadow-sm
              "
            >
              <CategorySnapshot
                data={
                  dashboardData.category_snapshot
                }
              />
            </div>


            <div
              className="
                md:col-span-2
                bg-white
                p-8
                rounded-[32px]
                shadow-sm
              "
            >
              <RiskReturnChart
                data={
                  dashboardData.risk_return
                }
              />
            </div>

          </div>

        </div>

      </section>


      {/* =====================================================
          CONSISTENT FUNDS
      ===================================================== */}

      <section
        className="
          py-24
          px-6
          lg:px-10
          bg-white
        "
      >

        <div className="max-w-7xl mx-auto">

          <div className="flex justify-between items-end mb-10">

            <div>

              <div
                className="
                  text-sm
                  uppercase
                  tracking-[0.3em]
                  text-green-700
                  font-bold
                  mb-4
                "
              >
                Orion Screened
              </div>

              <h2
                className="
                  text-5xl
                  font-black
                "
              >
                Consistent Funds
              </h2>

            </div>

            <a href="/mfe/">

              <button
                className="
                  bg-green-700
                  hover:bg-green-800
                  text-white
                  px-6
                  py-3
                  rounded-2xl
                  font-bold
                  transition-all
                "
              >
                Open Explorer
              </button>

            </a>
          </div>


          <div
            className="
              bg-[#f8faf9]
              p-8
              rounded-[32px]
            "
          >

            <ConsistentFunds
              data={
                dashboardData.consistent_funds
              }
            />

          </div>

        </div>

      </section>


      {/* =====================================================
          HEATMAP
      ===================================================== */}

      <section className="py-24 px-6 lg:px-10">

        <div className="max-w-7xl mx-auto">
                    <div className="flex justify-between items-end mb-10">

          {/*<h2 className="text-5xl font-black mb-10">*/}
          {/*  Fund Heatmap*/}
          {/*</h2>*/}
           <div>

              <div
                className="
                  text-sm
                  uppercase
                  tracking-[0.3em]
                  text-green-700
                  font-bold
                  mb-4
                "
              >
                Orion Screened
              </div>

              <h2
                className="
                  text-5xl
                  font-black
                "
              >
                Fund Heatmap
              </h2>

            </div>

            <a href="/mfe/">

              <button
                className="
                  bg-green-700
                  hover:bg-green-800
                  text-white
                  px-6
                  py-3
                  rounded-2xl
                  font-bold
                  transition-all
                "
              >
                Open Explorer
              </button>

            </a>
          </div>

          <div
            className="
              bg-white
              p-8
              rounded-[32px]
              shadow-sm
            "
          >

            <CategoryHeatmap
              data={dashboardData.heatmap}
            />

          </div>

        </div>

      </section>


      {/* =====================================================
          TOP FUNDS
      ===================================================== */}

      <section
        className="
          py-24
          px-6
          lg:px-10
          bg-white
        "
      >

        <div className="max-w-7xl mx-auto">

          <div className="flex justify-between items-end mb-10">

            <div>

              <div
                className="
                  text-sm
                  uppercase
                  tracking-[0.3em]
                  text-green-700
                  font-bold
                  mb-4
                "
              >
                Top Screened Funds
              </div>

              <h2
                className="
                  text-5xl
                  font-black
                "
              >
                Top Performing Funds
              </h2>

            </div>


            <a href="/mfe/">

              <button
                className="
                  bg-green-700
                  hover:bg-green-800
                  text-white
                  px-6
                  py-3
                  rounded-2xl
                  font-bold
                  transition-all
                "
              >
                Open Explorer
              </button>

            </a>

          </div>

          <TopFundsTable
            data={dashboardData.top_funds}
          />

        </div>

      </section>


      {/* =====================================================
          CATEGORY GRID
      ===================================================== */}

      <section className="py-20 px-6 lg:px-10">

        <div
          className="
            max-w-7xl
            mx-auto
            grid
            grid-cols-2
            md:grid-cols-4
            gap-6
          "
        >

          {[
            "Equity",
            "Debt",
            "Hybrid",
            "ELSS",
          ].map((c, i) => (

            <div
              key={i}
              className="
                bg-white
                rounded-[28px]
                p-10
                text-center
                font-bold
                text-2xl
                shadow-sm
                hover:-translate-y-1
                hover:shadow-lg
                transition-all
              "
            >
              {c}
            </div>

          ))}

        </div>

      </section>


      {/* =====================================================
          FINAL CTA
      ===================================================== */}

      <section
        className="
          py-24
          px-6
          lg:px-10
        "
      >

        <div
          className="
            max-w-7xl
            mx-auto
            rounded-[42px]
            bg-gradient-to-r
            from-green-900
            via-green-700
            to-green-500
            p-14
            text-white
            text-center
            shadow-[0_20px_60px_rgba(0,128,0,0.18)]
          "
        >

          <div
            className="
              text-5xl
              font-black
              mb-6
            "
          >
            Ready To Build
            Your Wealth?
          </div>

          <div
            className="
              text-xl
              text-white/85
              max-w-3xl
              mx-auto
              leading-relaxed
              mb-10
            "
          >
            Explore mutual funds, compare
            risk-adjusted performance and
            invest seamlessly through
            trusted AMC platforms.
          </div>


          <div
            className="
              flex
              flex-wrap
              justify-center
              gap-5
            "
          >

            <a href="/mfe/">

              <button
                className="
                  bg-white
                  text-green-800
                  px-8
                  py-4
                  rounded-2xl
                  font-bold
                  text-lg
                  shadow-lg
                  hover:scale-105
                  transition-all
                "
              >
                Explore Funds
              </button>

            </a>


            <a href="/mfpartners/">

              <button
                className="
                  border
                  border-white/30
                  bg-white/10
                  backdrop-blur-md
                  text-white
                  px-8
                  py-4
                  rounded-2xl
                  font-bold
                  text-lg
                  hover:bg-white/20
                  transition-all
                "
              >
                AMC Investment Platforms
              </button>

            </a>

          </div>

        </div>

      </section>

    </div>
  );
};

export default MFHomeStandalone;